import { Elements } from '@stripe/react-stripe-js'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { PaymentAPI } from '../../api/PaymentAPI'
import { SubscriptionAPI } from '../../api/SubscriptionAPI'
import SubscriptionForm from "./SubscriptionForm"
import Loader from '../../component/Loader'

const Subscription = () => {
    const [stripePromise, setStripePromise] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const hasFetchedRef = useRef(false);
    const userInStore = useSelector((state) => state.user);
    const location = useLocation();
    let stateObj = location?.state;

    useEffect(() => {
        if (!hasFetchedRef.current) {
            hasFetchedRef.current = true;
            if (userInStore.userInfo.userId) {
                createPaymentClientSecret();
            }
        }
    }, [userInStore.userInfo.userId]);


    const createPaymentClientSecret = async () => {
        try {
            setIsLoading(true);
            const clubId = userInStore.selectedClub?.clubId || userInStore.clubId;
            const publishKey = await PaymentAPI.getPublishKey();
            let stripeAccount;
            if (clubId) {
                try {
                    const connected = await PaymentAPI.getAdminConnectedAccountId({
                        userId: userInStore.userInfo.userId,
                        clubId,
                    });
                    stripeAccount = connected?.Data;
                } catch (connectedError) {
                    stripeAccount = undefined;
                }
            }
            setStripePromise(stripeAccount
                ? loadStripe(publishKey.Data, { stripeAccount })
                : loadStripe(publishKey.Data));
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);

        }
    }


    const appearance = {
        theme: 'flat',
        rules: {
            '.Input': {
                border: '1px solid rgba(156, 150, 150, 0.358)',
                boxShadow: 'none',
            },
            '.Input:focus': {
                border: '1px solid #8fbd04',
                boxShadow: 'none',
            },
            '.Input--invalid': {
                borderColor: '#df1b41',
            },
            '.Tab': {
                padding: '10px 15px',
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.52)'
            },
            '.Tab--selected': {
                backgroundColor: '#8fbd04',
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.52)'
            },
            '.Tab--selected:focus': {
                "outline": '2px solid #8fbd04',
                "boxShadow": 'none'
            },
            '.TabLabel': {
                color: '#30313d',
            },
            '.Label': {
                fontWeight: '500',
            },
        },
    };
    const options = {
        clientSecret: stateObj?.clientSecretKey,
        appearance,
    };
    return (
        <div className='subscription_payment_container'>
            {isLoading && <Loader />}
            <h1>Purchase your plan</h1>
            {stripePromise && (
                <Elements stripe={stripePromise} options={options}>
                    <SubscriptionForm stateObj={stateObj} userInStore={userInStore} />
                </Elements>
            )}
        </div>
    )
}

export default Subscription